export const MOODS = [
  { id: 'happy', label: '快乐', emoji: '😊', color: '#FFD93D' },
  { id: 'sad', label: '悲伤', emoji: '😢', color: '#6C9BCF' },
  { id: 'energetic', label: '充满活力', emoji: '⚡', color: '#FF6B6B' },
  { id: 'relaxed', label: '放松', emoji: '😌', color: '#95E1D3' },
  { id: 'angry', label: '愤怒', emoji: '😡', color: '#C34A36' },
  { id: 'nostalgic', label: '怀旧', emoji: '🌅', color: '#E8A87C' },
];

export const ACTIVITIES = [
  { id: 'workout', label: '运动', emoji: '💪', color: '#FF6B6B' },
  { id: 'study', label: '学习', emoji: '📚', color: '#6C9BCF' },
  { id: 'sleep', label: '睡眠', emoji: '🌙', color: '#3D5A80' },
  { id: 'party', label: '聚会', emoji: '🎉', color: '#FFD93D' },
  { id: 'relax', label: '放松', emoji: '☕', color: '#95E1D3' },
  { id: 'roadtrip', label: '公路旅行', emoji: '🚗', color: '#E8A87C' },
];

export const GENRES = [
  { id: 'pop', label: '流行', color: '#FF6B9D' },
  { id: 'rock', label: '摇滚', color: '#C34A36' },
  { id: 'hiphop', label: '嘻哈', color: '#FFB347' },
  { id: 'jazz', label: '爵士', color: '#6C9BCF' },
  { id: 'classical', label: '古典', color: '#95E1D3' },
  { id: 'edm', label: 'EDM', color: '#A855F7' },
  { id: 'indie', label: '独立', color: '#E8A87C' },
  { id: 'country', label: '乡村', color: '#D4A574' },
];

export const TEMPOS = [
  { id: 'slow', label: '慢速', bpmRange: [40, 80] },
  { id: 'medium', label: '中速', bpmRange: [80, 120] },
  { id: 'fast', label: '快速', bpmRange: [120, 200] },
];

export const ENERGY_LEVELS = [
  { id: 'low', label: '低' },
  { id: 'medium', label: '中' },
  { id: 'high', label: '高' },
];

export const DANCEABILITY_LEVELS = [
  { id: 'low', label: '低' },
  { id: 'medium', label: '中' },
  { id: 'high', label: '高' },
];

export const ACOUSTICNESS_LEVELS = [
  { id: 'low', label: '低' },
  { id: 'medium', label: '中' },
  { id: 'high', label: '高' },
];

export const VOCAL_STYLES = [
  { id: 'instrumental', label: '器乐' },
  { id: 'lyrical', label: '歌词' },
  { id: 'duet', label: '二重唱' },
];

export const THEMES = [
  { id: 'summer', label: '夏季热歌', emoji: '☀️', moods: ['happy', 'energetic'], activities: ['party', 'roadtrip'], genres: ['pop', 'edm'] },
  { id: 'winter', label: '冬季放松', emoji: '❄️', moods: ['relaxed', 'nostalgic'], activities: ['relax', 'sleep'], genres: ['classical', 'indie'] },
  { id: 'birthday', label: '生日派对', emoji: '🎂', moods: ['happy', 'energetic'], activities: ['party'], genres: ['pop'] },
  { id: '80s', label: '80 年代经典', emoji: '📼', moods: ['nostalgic', 'happy'], activities: ['party', 'roadtrip'], genres: ['rock', 'pop'] },
  { id: 'superhero', label: '超级英雄', emoji: '🦸', moods: ['energetic', 'angry'], activities: ['workout'], genres: ['rock', 'edm'] },
  { id: 'rainy', label: '雨天蓝调', emoji: '🌧️', moods: ['sad', 'relaxed'], activities: ['relax'], genres: ['indie', 'jazz'] },
];

export const RECOMMENDATIONS = {
  'Taylor Swift': ['Olivia Rodrigo', 'Lorde', 'Gracie Abrams'],
  'Eminem': ['Kendrick Lamar', 'J. Cole', 'NF'],
  'The Weeknd': ['Dua Lipa', 'Doja Cat', 'Troye Sivan'],
  'Adele': ['Sam Smith', 'Lewis Capaldi', 'Hozier'],
  'Coldplay': ['Imagine Dragons', 'OneRepublic', 'Keane'],
  'Miles Davis': ['John Coltrane', 'Thelonious Monk', 'Herbie Hancock'],
  'Avicii': ['Martin Garrix', 'Marshmello', 'Calvin Harris'],
  'Bon Iver': ['Fleet Foxes', 'Sufjan Stevens', 'Iron & Wine'],
  'Queen': ['Led Zeppelin', 'The Beatles', 'Deep Purple'],
  'John Denver': ['James Taylor', 'Gordon Lightfoot', 'Jim Croce'],
  'Drake': ['Travis Scott', 'Post Malone', 'Future'],
  'Linkin Park': ['Breaking Benjamin', 'Three Days Grace', 'Evanescence'],
};
